import * as mws from '../../../../shared/MwsViewModels';
import { Vue, Component, Prop } from 'vue-property-decorator';
import template from './canada-performance-and-portfolio-bar-chart.vue';

@Component({
  mixins: [template]
})
export default class CanadaPerformanceAndPortfolioBarChart extends Vue {
    @Prop()
    chartData: mws.CanadaPerformanceAndPortfolioBarChart;

    @Prop()
    tabIndex: number;

    @Prop() 
    itemIndex: number;
}